import { render, staticRenderFns } from "./SignosVitales.vue?vue&type=template&id=f094167a"
import script from "./SignosVitales.vue?vue&type=script&lang=js"
export * from "./SignosVitales.vue?vue&type=script&lang=js"
import style0 from "./SignosVitales.vue?vue&type=style&index=0&id=f094167a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports